module.exports = __webpack_public_path__ + "static/img/photo-about_m.8b69cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medium/photo-about_m.jpg
// module id = Ekns
// module chunks = 1